<template>
  <Layout>
    <PageHeader :title="$t(title)"/>
    <div class="row">     
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">            
            <div class="row">
              <div class="col-md-6">
                <div class="list-group">
                  <router-link class="list-group-item" v-for="dir in directories" 
                              :key="dir" :to="{ name: 'AccessControl', params: { dir } }">
                      {{ dir }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>         
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import userApi from '../../../api/userApi'

export default {
    name: 'ControlPanel',
    components: {
      Layout,
      PageHeader
    },
    data() {
      return {
        title: 'pages.documents.pdfviewer.next',
        directories: {}
      }
    },
    methods: {
      
    },

    created() {
      userApi.addDirectories().then(res => {
        this.directories = JSON.parse(res.data);
      })
    }
}
</script>

<style>

</style>